export default __webpack_public_path__ + "static/media/CertificateIEC.c313ce97.png";